/* eslint-disable no-debugger */
import useStandardKendoReport from './useStandardKendoReport';
import ReportParameters from './ReportParameters';
import ReportGrid from './ReportGrid';

const StandardKendoReport = ({
  reportInfoId,
  reportParameters,
  title,
  parameters = [],
  columns = [],
  usePagination = false,
  pageSize = undefined,
  enablePdfExport = true,
  enableExcelExport = true,
  gridHeight = '400px',
  detailArrayName,
  detailReportTitle,
  detailGridHeight,
  excelColumns = [],
  exportDetailData
}) => {
  const {
    reportData,
    isLoaded,
    formValues,
    onFormValueChanged,
    onFormDateValueChanged,
    handleRefresh,
    hasSubReportColumn,
    generateSubReportColumns,
    hasRowSubReportData,
    onValueTextPairChanged
  } = useStandardKendoReport(reportInfoId, reportParameters, detailArrayName);

  return (
    <div>
        {parameters.length > 0 && (
          <ReportParameters
            title={title}
            formValues={formValues}
            onFormValueChanged={onFormValueChanged}
            onFormDateValueChanged={onFormDateValueChanged}
            onValueTextPairChanged={onValueTextPairChanged}
            onRefresh={handleRefresh}
            parameters={parameters}
          />
        )}
        <ReportGrid
          reportData={reportData}
          isLoaded={isLoaded}
          columns={columns}
          title={title}
          hasSubReportColumn={hasSubReportColumn}
          generateSubReportColumns={generateSubReportColumns}
          hasRowSubReportData={hasRowSubReportData}
          usePagination={usePagination}
          pageSize={pageSize}
          enablePdfExport={enablePdfExport}
          enableExcelExport={enableExcelExport}
          gridHeight={gridHeight}
          detailArrayName={detailArrayName}
          detailReportTitle={detailReportTitle}
          detailGridHeight={detailGridHeight}
          excelColumns={excelColumns}
          exportDetailData={exportDetailData}
        />
    </div>
  );
};

export default StandardKendoReport;
